import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'accessibility_mode';

@Injectable({ providedIn: 'root' })
export class AccessibilityService {
    private initialValue = localStorage.getItem(STORAGE_KEY) === 'true';
    
    private accessibilityModeSubject = new BehaviorSubject<boolean>(this.initialValue);

    accessibilityMode$ = this.accessibilityModeSubject.asObservable();

    setAccessibilityMode(value: boolean) {
        localStorage.setItem(STORAGE_KEY, String(value));
        this.accessibilityModeSubject.next(value);
    }

    toggle() {
        this.setAccessibilityMode(!this.accessibilityModeSubject.value);
    }

    get value(): boolean {
        return this.accessibilityModeSubject.value;
    }
}
